export var ErrorCodes = /*#__PURE__*/ function(ErrorCodes) {
    ErrorCodes["IncorrectRequestType"] = "INCORRECT_REQUEST_TYPE";
    ErrorCodes["AccessRestricted"] = "ACCESS_RESTRICTED";
    ErrorCodes["UnAuthorised"] = "UN_AUTHORISED";
    ErrorCodes["UrlNotFound"] = "URL_NOT_FOUND";
    ErrorCodes["NoContent"] = "NO_CONTENT";
    ErrorCodes["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ErrorCodes["InvalidInputs"] = "INVALID_INPUTS";
    ErrorCodes["NotFound"] = "NOT_FOUND";
    ErrorCodes["RecordDeleted"] = "RECORD_DELETED";
    ErrorCodes["RecordArchived"] = "RECORD_ARCHIVED";
    ErrorCodes["TimesheetApproved"] = "TIMESHEET_APPROVED";
    ErrorCodes["CustomDomainFailure"] = "CUSTOM_DOMAIN_FAILURE";
    ErrorCodes["EmailDomainFailure"] = "EMAIL_DOMAIN_FAILURE";
    ErrorCodes["TokenInvalid"] = "TOKEN_INVALID";
    ErrorCodes["AttachmentSizeExceeded"] = "ATTACHMENT_SIZE_EXCEEDED";
    ErrorCodes["IntegrationSettingsInvalidInput"] = "INTEGRATION_SETTINGS_INVALID_INPUT";
    ErrorCodes["IntegrationSettingsBadState"] = "INTEGRATION_SETTINGS_BAD_STATE";
    ErrorCodes["ConflictingFieldValue"] = "CONFLICTING_FIELD_VALUE";
    ErrorCodes["PaymentFailed"] = "PAYMENT_FAILED";
    ErrorCodes["LimitReached"] = "LIMIT_REACHED";
    ErrorCodes["InvalidOtp"] = "INVALID_OTP";
    ErrorCodes["NoSlackIntegrationsFound"] = "NO_SLACK_INTEGRATIONS_FOUND";
    ErrorCodes["NoWebhooksFound"] = "NO_WEBHOOKS_FOUND";
    ErrorCodes["NoSFIntegrationsFound"] = "NO_SF_INTEGRATIONS_FOUND";
    ErrorCodes["NitroOutOfCredits"] = "NITRO_OUT_OF_CREDITS";
    ErrorCodes["NitroCreditsExpired"] = "NITRO_CREDITS_EXPIRED";
    ErrorCodes["Nitro80PercentUsed"] = "NITRO_80_PERCENT_USED";
    ErrorCodes["Nitro90PercentUsed"] = "NITRO_90_PERCENT_USED";
    ErrorCodes["Nitro100PercentUsed"] = "NITRO_100_PERCENT_USED";
    return ErrorCodes;
}({});
